function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
    // 生成随机时间
    function generateRandomTime() {
      var hours = Math.floor(Math.random() * 15) + 1
      var minutes = Math.floor(Math.random() * 60)
      var seconds = Math.floor(Math.random() * 60)
      //总共的毫秒数
      var targetTime = (hours * 3600 + minutes * 60 + seconds) * 1000

      return targetTime
    }
    function TimeDown(value) {
      //倒计时的总秒数
      var totalSeconds = parseInt(value / 1000)
      //取模（余数）
      var modulo = totalSeconds % (60 * 60 * 24)
      //小时数
      var hours = Math.floor(modulo / (60 * 60))
      modulo = modulo % (60 * 60)
      //分钟
      var minutes = Math.floor(modulo / 60)
      //秒
      var seconds = modulo % 60

      hours = hours.toString().length == 1 ? '0' + hours : hours
      minutes = minutes.toString().length == 1 ? '0' + minutes : minutes
      seconds = seconds.toString().length == 1 ? '0' + seconds : seconds

      //输出到页面
      $('.hours').html(hours)
      $('.minutes').html(minutes)
      $('.seconds').html(seconds)
      //延迟一秒执行自己
      if (hours == '00' && minutes == '00' && parseInt(seconds) - 1 < 0) {
      } else {
        setTimeout(function () {
          TimeDown(value - 1000)
        }, 1000)
      }
    }
    TimeDown(generateRandomTime())
    // 头部固定
    $('header').addClass('stiky')
    $(document).scroll(function (e) {
      var beforScrollTop = $(document).scrollTop()
      setTimeout(function () {
        $('header').addClass('stiky')
      }, 50)
    })
    new Swiper('.mySwiper', {
      slidesPerView: 'auto',
      spaceBetween: 10,
      centeredSlides: true,
      loop: true, //循环滚动
      freeMode: true,
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
    })
    // new Swiper('.mySwiper1', {
    //   loop: true,
    //   autoplay: {
    //     delay: 3000,
    //     stopOnLastSlide: false,
    //     disableOnInteraction: false,
    //   },
    // })
    // new Swiper('.mySwiper2', {
    //   slidesPerView: 'auto',
    //   spaceBetween: 141,
    //   centeredSlides: true,
    //   loop: true, //循环滚动
    //   freeMode: true,
    //   speed: 4500, //匀速时间
    //   autoplay: {
    //     delay: 0,
    //     stopOnLastSlide: false,
    //     disableOnInteraction: false,
    //   },
    // })
    // new Swiper('.mySwiper3', {
    //   slidesPerView: 'auto',
    //   spaceBetween: 163,
    //   centeredSlides: true,
    //   loop: true, //循环滚动
    //   freeMode: true,
    //   speed: 4000, //匀速时间
    //   autoplay: {
    //     delay: 0,
    //     stopOnLastSlide: false,
    //     disableOnInteraction: false,
    //   },
    // })
    // new Swiper('.mySwiper4', {
    //   slidesPerView: 'auto',
    //   spaceBetween: 152,
    //   centeredSlides: true,
    //   loop: true, //循环滚动
    //   freeMode: true,
    //   speed: 3500, //匀速时间
    //   autoplay: {
    //     delay: 0,
    //     stopOnLastSlide: false,
    //     disableOnInteraction: false,
    //   },
    // })
    // new Swiper('.mySwiper5', {
    //   slidesPerView: 'auto',
    //   spaceBetween: 107,
    //   centeredSlides: true,
    //   loop: true, //循环滚动
    //   freeMode: true,
    //   speed: 4500, //匀速时间
    //   autoplay: {
    //     delay: 0,
    //     stopOnLastSlide: false,
    //     disableOnInteraction: false,
    //   },
    // })
    // 弹窗
    $('.sp-public-btn,.btn-style,.sp-head-btns').click(function () {
      $('.sp-mask').css('display', 'flex')
      updateSlider(0, '.size-pop')
    })
    $('.sp-close-btn').click(function () {
      $('.sp-mask').css('display', 'none')
    })
    //加减
    let sp_price1 = 13.49
    let sp_price2 = 19.62

    function calcTotal(price, num) {
      let _result = Number(price) * Number(num)
      if (_result > 50) {
        // $('.product-part .sp-tip').css('display', 'flex')
        $('.product-part .btn-free').css('display', 'flex')
      } else {
        // $('.product-part .sp-tip').hide()
        $('.product-part .btn-free').hide()
      }
      return _result.toFixed(2)
    }
    
    let prods = window.product
	function getCur(that){
	  let product_con = $(that).closest('.product-part');
	  let color = product_con.find('#color div.active').attr('data-val')
	  let size = product_con.find('#Size div.active').attr('data-val')
	  return prods.filter(item=> item.option1 == color && item.option2 == size )[0]
	}
	function changePrice(that){
	  let product_con = $(that).closest('.product-part');
	  let num = product_con.find('#calcNumber').val()
	  let that1 = that
	  let price = (getCur(that1).price * num / 100).toFixed(2)
	  let compare = (getCur(that1).compare_at_price * num / 100).toFixed(2)
      if (price >= 50) {
        product_con.find('.btn-free').css('display', 'flex')
      } else {
        // $('.product-part .sp-tip').hide()
        product_con.find('.btn-free').hide()
      }
	  price = (price + '').replace('.', ',')
	  compare = (compare + '').replace('.', ',')
	  product_con.find('#new').html(price)
	  product_con.find('#old').html(compare)
	  let off_font = 100 - Math.ceil(getCur(that1).price / getCur(that1).compare_at_price * 100)
	  $(".product-part .price-group .sp-frees em").html(off_font);
	}
	$('.sp-btn-style').click(function(){
	  let that = this
	  let product_con = $(that).closest('.product-part');
	  let num = product_con.find('#calcNumber').val()
	  window.location.href = '/cart/' + getCur(that).id + ':' + num
	})
    // 数字框
    $('.reduce').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) - 1
      if (num > 0) {
        input.value = num
      }
      let that = this
      changePrice(that)
    })
    $('.add').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) + 1
      input.value = num
      let that = this
      changePrice(that)
    })
    // const tabs = $('.sp-tab')
    // let currentIndex = 0
    // function nextTabFunc() {
    //   const currentTab = tabs[currentIndex]
    //   currentTab.classList.add('sp-tab-ani')
    //   let nextIndex = (currentIndex + 1) % tabs.length
    //   const nextTab = tabs[nextIndex]
    //   setTimeout(() => {
    //     currentTab.classList.remove('sp-tab-ani')
    //   }, 2500),
    //     (currentIndex = (currentIndex + 1) % tabs.length),
    //     setTimeout(nextTabFunc, 1500)
    // }
    // nextTabFunc()
    // style选项
    let typeOptions = $('#color .option')
    let imgArr = [
      'https://cdn.shopify.com/s/files/1/0549/3840/2918/files/20250619-Silver-bg.png',
      'https://cdn.shopify.com/s/files/1/0549/3840/2918/files/20250619-Black-bg.png',
      'https://cdn.shopify.com/s/files/1/0549/3840/2918/files/20250619-Pink-bg.png',
      'https://cdn.shopify.com/s/files/1/0549/3840/2918/files/20250619-Gold-bg.png',
      'https://cdn.shopify.com/s/files/1/0549/3840/2918/files/20250619-Blue-bg.png',
      'https://cdn.shopify.com/s/files/1/0549/3840/2918/files/20250619-Red-bg.png',
    ]
    let imgArr2 = [
      'https://cdn.shopify.com/s/files/1/0549/3840/2918/files/20250619-Silver-line.png',
      'https://cdn.shopify.com/s/files/1/0549/3840/2918/files/20250619-Black-line.png',
      'https://cdn.shopify.com/s/files/1/0549/3840/2918/files/20250619-Pink-line.png',
      'https://cdn.shopify.com/s/files/1/0549/3840/2918/files/20250619-Gold-line.png',
      'https://cdn.shopify.com/s/files/1/0549/3840/2918/files/20250619-Blue-line.png',
      'https://cdn.shopify.com/s/files/1/0549/3840/2918/files/20250619-Red-line.png',
    ]
    let imgArr3 = [
      'https://cdn.shopify.com/s/files/1/0549/3840/2918/files/20250619-Silver.png',
      'https://cdn.shopify.com/s/files/1/0549/3840/2918/files/20250619-Black.png',
      'https://cdn.shopify.com/s/files/1/0549/3840/2918/files/20250619-Pink.png',
      'https://cdn.shopify.com/s/files/1/0549/3840/2918/files/20250619-Gold.png',
      'https://cdn.shopify.com/s/files/1/0549/3840/2918/files/20250619-Blue.png',
      'https://cdn.shopify.com/s/files/1/0549/3840/2918/files/20250619-Red.png',
    ]
    $(".option").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    let that = this
    changePrice(that)
  });
    typeOptions.click(function () {
      var index = $(this).index()
      if ($('.sp-mask').css('display') == 'flex') {
        updateSlider(index, '.size-pop')
      } else {
        updateSlider(index)
      }
      $('.top-product').css({
        'background-image': 'url(' + imgArr[index] + ')',
      })
      $('.sp-lines i').css({
        'background-image': 'url(' + imgArr2[index] + ')',
      })
    })
    let textArr = ['16GB','32GB','64GB','128GB','256GB','512GB']
    $('#Size .option').click(function () {
      var text = $(this).text()
      var index2 = $(this).index()
      $('.sp-lines span').html(textArr[index2])
      // if (index2 == 6) {
      //   $('.sp-lines span').html('1TB')
      // } else {
      //   $('.sp-lines span').html(text)
      // }
    })
    // style选项
    $('.cart-btn').click(function () {
      $(this).children('img').addClass('on')
      setTimeout(function () {
        $('.cart-btn').children('img').removeClass('on')
      }, 500)
      $('.sp-header-top .sp-cart').addClass('on')
      setTimeout(function () {
        $('.sp-header-top .sp-cart').removeClass('on')
      }, 500)
    })
    // 加入购物车
    addCart()
    function addCart() {
      // 加入购物车
      $('.addCerts').click(function () {
        // do something here
        let that = this
        var data = {
		  id: getCur(that).id,
		  quantity: $(this).closest('.product-part').find('#calcNumber').val(),
		};
		$.ajax({
		  type: "POST",
		  url: "/cart/add.js",
		  data: data,
		  success: function () {
			$.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
			  $("#cardNum").html(result.item_count);
			  $('.sp-cart .num').css('background', '#cf0101')
			});
		  },
		  dataType: "json",
		});
        var img = $(this).closest('.product-part').find('.sp-pro-imgs img.active')
        var flyer = img[0].cloneNode(true)
        flyer.classList.add('clone')
        $(this).closest('.product-part').append(flyer)
        $('.clone').css({
          width: img.width(),
          height: img.height(),
          position: 'fixed',
          top: img[0].offsetTop,
          left: img.offset().left,
          'z-index': '99999',
        })
        var offset = $('.sp-cart')[0].getBoundingClientRect()
        $('.sp-cart').addClass('shake')
        setTimeout(() => {
          $('.sp-cart').removeClass('shake')
        }, 1000)
        let finish = $('.sp-cart')
        $('.clone').animate(
          {
            top: finish[0].offsetTop + 117,
            left: finish[0].offsetLeft + finish.width() / 2 - 15,
            width: 50, // 结束时的大小，根据需要调整
            height: 50, // 结束时的大小，根据需要调整
            opacity: 0.4,
          },
          1000,
          'linear',
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach() // 完成动画后移除克隆的图片
              }
            )
          }
        )
      })
    }
    function updateSlider(index, query) {
      if (query) {
        var images = document.querySelectorAll('.size-pop .slider-images img'),
          water = document.querySelectorAll('.size-pop .top-product .sp-bg')
      } else {
        var images = document.querySelectorAll('.slider-images img'),
          water = document.querySelectorAll('.top-product .sp-bg')
      }
      var imageIndex = index
      function getPrevImageIndex() {
        return (imageIndex - 1 + images.length) % images.length
      }
      function getNextImageIndex() {
        return (imageIndex + 1) % images.length
      }
      let prevImageIndex = getPrevImageIndex(),
        nextImageIndex = getNextImageIndex()
      images.forEach((image) => {
        image.classList.remove('active', 'previous', 'next', 'inactive')
      }),
        water.forEach((water2) => {
          water2.classList.remove('active', 'inactive')
        }),
        water[imageIndex].classList.add('active'),
        images[imageIndex].classList.add('active'),
        images[prevImageIndex].classList.add('previous'),
        images[nextImageIndex].classList.add('next'),
        images.forEach((image, index) => {
          index !== imageIndex &&
            index !== prevImageIndex &&
            index !== nextImageIndex &&
            image.classList.add('inactive')
        }),
        water.forEach((water2, index) => {
          index !== imageIndex && water2.classList.add('inactive')
        }),
        (imageIndex = nextImageIndex),
        $('.sp-group .sp-p')
          .eq(imageIndex - 1)
          .addClass('sp-active')
          .siblings()
          .removeClass('sp-active')
    }
    updateSlider(0)
    //, setInterval(updateSlider, 3e3)
  })
  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image()
        img.src = url
      })
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    // preloadImages(imagesOneDim)
    // preloadImages(imagesTwoDim)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop - $('header').height()
        window.scroll({
          top: offsetTop * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }
}

mainRender()
